import { useCurrentConnector } from '@fuels/react';
import { getFuelConnectorIcon } from '../utils/getConnectorIcon';

export const useConnectedFuelIcon = () => {
  const { currentConnector } = useCurrentConnector();
  return getFuelConnectorIcon(currentConnector?.name);
};
